export const environment = {
  production: true,
  apiHost: 'http://api-prueba1.gesdencolegiosone.es/api/'
};
